<template>
  <transition name="slideUp">
    <div id="route" v-if="active">
      <div class="route__header">
        <div class="route__header-content">
          <div class="header__title">
            <svg class="icon icon-compass" aria-hidden="true" role="img">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-compass"></use>
            </svg>
            Itinéraire
          </div>
          
          <span class="distance">{{ formatRouteDistanceAndTime() }}</span>
        </div>
        <ul class="group-buttons">
          <li>
            <button @click="expandRoute">
              <svg v-if="expand" class="icon icon-reduce" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-reduce"></use>
              </svg>
              <svg v-else class="icon icon-expand" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </li>
          <li>
            <button @click="closeRoute">
              <svg class="icon icon-close" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
              </svg>
            </button>
          </li>
        </ul>
      </div>

      <div class="route__content" v-show="expand">
        <span v-if="loading" class="loader"></span>
        <form action="#" @submit.prevent="getWayPoints">
          <span class="error" v-if="error">Un problème est survenu</span>
          <div class="form__row">
             <input type="text" placeholder="Départ" v-model="start" tabindex="1" required>
             <span class="button" @click.prevent="switchInputValues">
               <svg class="icon icon-inverse" aria-hidden="true" role="img">
                 <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-inverse"></use>
               </svg>
             </span>
          </div>
          <div class="form__row">
            <input type="text" placeholder="Arrivée" v-model="end" tabindex="2" required>
            <button type="submit" tabindex="5">
              <svg class="icon icon-search" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-search"></use>
              </svg>
            </button>
          </div>
          <div class="form__row">
            <input type="radio" name="type" id="drive" value="DRIVING" v-model="costingVal"><label for="drive" tabindex="3">En voiture</label>
            <input type="radio" name="type" id="walk" value="WALKING" v-model="costingVal"><label for="walk" tabindex="4">A pied</label>
          </div>
        </form>
        <div class="routing__container">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  /* global L */
  /* global cgy_vars */
  /* global google */
  /* eslint no-undef: "error" */
  import store from '../store/store'
  import { OpenStreetMapProvider } from 'leaflet-geosearch'
  const provider = new OpenStreetMapProvider()
  // import json from '../store/jsonUrl'

  export default {
    name: 'route',
    data () {
      return {
        active: false,
        expand: false,
        routeFound: false,
        error: false,
        loading: false,
        iconUrl: cgy_vars.defaultMarker,
        provider: provider,
        start: '',
        end: '',
        startClean: '',
        endClean: '',
        routeSummary: '',
        waypoints: [],
        costingVal: 'DRIVING',
        markers: [],
        routing: '',
        strokeColor: cgy_vars.line.strokeColor,
        pointMarkerStyle: {
          radius: 5,
          color: cgy_vars.line.strokeColor,
          fillColor: 'white',
          opacity: 1,
          fillOpacity: 0.7
        }
      }
    },
    methods: {
      routeOnClick: function (place) {
        this.active = true
        this.expand = true
        if (place) {
          this.start = `${place.lat}, ${place.lng}`
        }
      },
      getWayPoints: function () {
        if (this.start === '' || this.end === '') {
          return
        }
        this.routeFound = false
        this.waypoints = []
        this.cleanAddr = []
        this.removePrevRoute()
        this.getLatLngFromAddress(this.start, false)
        this.getLatLngFromAddress(this.end, true)
      },
      getLatLngFromAddress: function (addr, isLast) {
        let that = this
        this.loading = true
        this.provider.search({query: addr}).then(function (data) {
          console.log(data)
          if (data.length > 0 && data[0].label) {
            that.error = false
            data = data[0]
            that.cleanAddr.push(data.label)
            that.waypoints.push(L.latLng(data.y, data.x))
            if (isLast) {
              that.displayRouteOnMap()
              that.loading = false
            }
          } else {
            that.error = true
            that.loading = false
            let container = document.querySelectorAll('.routing__container')[0]
            container.innerHTML = ''
          }
        }).catch(function (error) {
          that.error = true
          that.loading = false
          let container = document.querySelectorAll('.routing__container')[0]
          container.innerHTML = ''
          console.log(error)
        })
      },
      displayRouteOnMap: function () {
        let that = this
        let markerIcon = L.icon({
          iconUrl: this.iconUrl,
          iconSize: [21, 26],
          iconAnchor: [10.5, 26]
        })
        this.routing = L.Routing.control({
          plan: L.Routing.plan(this.waypoints, {
            createMarker: function (i, wp) {
              return L.marker(wp.latLng, {icon: markerIcon, draggable: false}).bindPopup(that.cleanAddr[i])
            }
          }),
          router: L.Routing.google({
            travelMode: google.maps.TravelMode[this.costingVal],
            provideRouteAlternatives: false
          }),
          addWaypoints: false,
          show: false,
          lineOptions: {
            styles: [{color: this.strokeColor, opacity: 1, weight: 5}]
          },
          language: 'fr'
        }).addTo(store.state.map).on('routingerror', function (error) {
          console.log(error)
          that.error = true
          that.removePrevRoute()
        }).on('routesfound', function (result) {
          that.displayRouteSummary(result)
          that.createItinary(result)
        })
      },
      displayRouteSummary: function (result) {
        this.routeFound = true
        this.routeSummary = result.routes[0].summary
        this.startClean = this.cleanAddr[0]
        this.endClean = this.cleanAddr[1]
      },
      createItinary: function (result) {
        let container = document.querySelectorAll('.routing__container')[0]
        container.innerHTML = ''
        let table = L.DomUtil.create('table', '')
        let steps = L.DomUtil.create('tbody', '', table)
        container.appendChild(table)

        let r = result.routes[0]

        for (let i = 0; i < r.instructions.length; i++) {
          let instr = r.instructions[i]
          let text = instr.text
          let distance = this.formatDistance(instr.distance)
          let step = this.createStep(i + 1, text, distance, steps)

          this.addRowListeners(step, r.coordinates[instr.index])
        }
        this.addStartAndEnd()

        return container
      },
      createStep: function (i, text, distance, steps) {
        let row = L.DomUtil.create('tr', '', steps)
        let td
        td = L.DomUtil.create('td', '', row)
        td.appendChild(document.createTextNode(`${i}.`))
        td = L.DomUtil.create('td', '', row)
        td.appendChild(document.createTextNode(text))
        td = L.DomUtil.create('td', '', row)
        td.appendChild(document.createTextNode(distance))
        return row
      },
      addStartAndEnd: function () {
        let steps = document.querySelectorAll('.routing__container table tbody')[0]
        let rowS = L.DomUtil.create('tr', '', steps)
        let rowE = L.DomUtil.create('tr', '', steps)
        let start = L.DomUtil.create('th', '', rowS)
        start.setAttribute('colspan', 3)
        var startSpan = document.createElement('span')
        startSpan.innerHTML = '<img src="' + cgy_vars.defaultMarker + '">' + this.startClean
        start.appendChild(startSpan)
        steps.insertBefore(rowS, steps.firstChild)
        let end = L.DomUtil.create('th', '', rowE)
        end.setAttribute('colspan', 3)
        var endSpan = document.createElement('span')
        endSpan.innerHTML = '<img src="' + cgy_vars.defaultMarker + '">' + this.endClean
        end.appendChild(endSpan)
        steps.appendChild(rowE)
      },
      addRowListeners: function (row, coordinate) {
        L.DomEvent.addListener(row, 'mouseover', function () {
          this._marker = L.circleMarker(coordinate,
            this.pointMarkerStyle).addTo(store.state.map)
        }, this)
        L.DomEvent.addListener(row, 'mouseout', function () {
          if (this._marker) {
            store.state.map.removeLayer(this._marker)
            delete this._marker
          }
        }, this)
        L.DomEvent.addListener(row, 'click', function (e) {
          store.state.map.panTo(coordinate)
          L.DomEvent.stopPropagation(e)
        }, this)
      },
      formatRouteDistanceAndTime: function () {
        if (!this.routeFound) {
          return ''
        }
        let distance = this.routeSummary.totalDistance
        let time = this.routeSummary.totalTime
        // format time
        if (time > 3600) {
          let h = Math.floor(time / 3600)
          let min = time % 60
          time = `${h} h ${min} min`
        } else if (time > 60) {
          time = `${Math.round(time / 60)} min`
        } else {
          time = `${time} sec.`
        }
        // format distance
        distance = this.formatDistance(distance)

        return `${distance} ~${time}`
      },
      formatDistance: function (d) {
        if (d > 1000) {
          d = `${+(d / 1000).toFixed(1)} km.`
        } else {
          d = `${d.toFixed(0)} m.`
        }
        return d
      },
      switchInputValues: function () {
        let tmp = this.start
        this.start = this.end
        this.end = tmp
      },
      removePrevRoute: function () {
        if (this.routing !== '') {
          this.routing.remove()
        }
      },
      closeRoute: function () {
        // close route panel
        this.removePrevRoute()
        this.active = false
        this.expand = false
      },
      expandRoute: function () {
        this.expand = !this.expand
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Route.vue?4ba469f3